<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="message-list"
            :url="url"
            :tableHeight="this.screenHeight - 175"
            :columns="columnList"
            dialogWidth="60%"
            :buttons="buttons"
            :addButton="{ permission: 'default' }"
            :deleteButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @loadSendMessageView="loadSendMessageView"
            @retractMessage="retractMessage"
        >
            <slot slot="filter">
                <el-col :span="8">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="sendType" :options="sendTypes" :clearable="true" placeholder="请选择通知形式"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
        <form-dialog :title="message.title" :visible.sync="message.dialogFormVisible" :data="message.data" :columns="sendMessageColumns" width="50%" @confirm="sendMessage"></form-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `MessageSend`,
    props: {

    },
    data() {
        return {
            title: `消息发送`,
            url: { baseURL: `/api/Operation/MessageHeader`,
                get: paras => {
                    return this.loadMessageHeader()
                },
                post: (row) => {
                    return this.saveMessage(row)
                },
                put: (row) => {
                    return this.saveMessage(row)
                } },
            buttons: [],
            usergroup: [],
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            isbobao: true,
            sendtypedefault: 1,
            templateList: [],
            templateoption: [],
            users: [],
            message: {
                dialogFormVisible: false,
                data: {},
                title: `请选择接收人`,
                messageId: 0
            },
            isShowTotalColumn: true,
            rdate: [
                this.$moment()
                    .add(-6, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`),
                this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            ],
            sendType: null,
            sendTypes: [{ label: `播报`, value: 1 }, { label: `信息`, value: 2 }]
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_WARD_AUTH`)
            this.$store.dispatch(`ADD_CURRENTUSER`)
            this.$store.dispatch(`enums/ADD_ALL_ENUM`)
            this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
            this.$store.dispatch(`ADD_RECOVERY_WARD_AUTH`)
        }
        this.loadUsers()
        this.loadGroup()
    },
    computed: {
        ...mapGetters([`sys_enums`, `ward_auth`, `operation_ward_auth`, `operation_room_auth`, `recovery_ward_auth`, `recovery_bed_auth`, `screenHeight`]),
        templateoptioncomputed() {
            let sendtype = 1
            if (this.isbobao === true) {
                sendtype = 1
            } else {
                sendtype = 2
            }
            let r = _.filter(this.templateoption, d => { return d.type === sendtype })
            return r
        },
        columnList() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                this.isShowTotalColumn = false
            }
            let viewlist = [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isKey: true
            }, {
                type: `datetime`,
                prop: `modify_date`,
                label: `时间`,
                width: `140`,
                isListable: true
            },
            {
                type: `radio`,
                prop: `send_type`,
                label: `通知形式`,
                colspan: 12,
                width: `80`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                default: this.sendtypedefault,
                options: this.sendTypes,
                change: (that, { row }) => {
                    this.sendtypedefault = row.send_type
                    if (row.send_type == 2) {
                        this.isbobao = false
                    } else {
                        this.isbobao = true
                    }
                    row.title = undefined
                    row.content = undefined
                    row.play_time = undefined
                    row.play_interval = undefined
                    row.sys_board_template_id = undefined
                }
            }, {
                type: `select`,
                prop: `sys_board_template_id`,
                label: `选择模板`,
                width: `200`,
                isEditable: true,
                isCreatable: true,
                options: this.templateoptioncomputed,
                change: (that, { row }) => {
                    let template = this.templateList.find(s => s.id == row.sys_board_template_id)
                    if (template) {
                        console.log(template)
                        row.send_type = template.send_type
                        row.title = template.title
                        row.content = template.content
                        row.play_time = template.play_time
                        row.play_interval = template.play_interval
                        // row.all = template.all
                        // row.sys_message_group_array = template.sys_messagegroup_ids
                        // row.ac_sys_user_array = template.ac_sysUser_ids
                        // row.notice_location = template.dic_ward_ids
                        if (template.send_type === 1) {
                            this.isbobao = true
                        } else if (template.send_type === 2) {
                            this.isbobao = false
                        }
                    }
                }
            },
            {
                type: `string`,
                prop: `title`,
                label: `通知标题`,
                width: `200`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `textarea`,
                prop: `content`,
                label: `内容`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                config: {
                    minRows: 6,
                    maxRows: 6
                }
            },
            {
                type: `string`,
                prop: `total`,
                label: `通知统计`,
                width: `80`,
                isListable: this.isShowTotalColumn
            },
            {
                type: `number`,
                prop: `play_time`,
                label: `播放次数`,
                colspan: 12,
                width: `80`,
                isListable: true,
                default: 1,
                isEditable: this.isbobao,
                isCreatable: this.isbobao
            },
            {
                type: `number`,
                prop: `play_interval`,
                label: `播放间隔(秒)`,
                colspan: 12,
                width: `100`,
                isListable: true,
                default: 1,
                isEditable: this.isbobao,
                isCreatable: this.isbobao
            },
            {
                type: `select`,
                prop: `enum_message_status`,
                label: `状态`,
                width: `80`,
                isListable: true,
                options: this.sys_enums.MessageStatus
            }, {
                type: `string`,
                prop: `sender`,
                label: `发送人`,
                width: `80`,
                isListable: true
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `220`,
                isListable: true,
                readonly: false,
                options: (that, { row }) => {
                    if (row.enum_message_status == 0) {
                        return [{
                            class: `is-plain`,
                            label: `发送`,
                            type: `primary`,
                            emit: `loadSendMessageView`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `编辑`,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `删除`,
                            type: `danger`,
                            emit: `DeleteData`,
                            permission: `default`
                        }]
                    } else if (row.enum_message_status == 1) {
                        return [{
                            class: `is-plain`,
                            label: `撤回`,
                            type: `primary`,
                            emit: `retractMessage`,
                            permission: `default`
                        }]
                    }
                }
            }]
            return viewlist
        },
        sendMessageColumns() {
            let list = [{
                type: `checkbox`,
                prop: `all`,
                label: `全部`
            }, {
                type: `multiselect`,
                prop: `sys_message_group_array`,
                label: `接收组`,
                options: this.usergroup,
                collapseTags: false
            }, {
                type: `multiselect`,
                prop: `ac_sys_user_array`,
                label: `接收人`,
                options: this.users,
                collapseTags: false
            }]
            if (this.message.data.send_type == 1) {
                list = [{
                    type: `selecttree`,
                    prop: `notice_location`,
                    label: `通知位置`,
                    options: this.loadnoticelocation,
                    collapseTags: false,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }]
            }
            return list
        }

    },
    mounted() {
        this.loadTemplate()
    },
    methods: {
        loadMessageHeader() {
            let that = this
            return new Promise(resolve => {
                let req = that.myaxios.get(`/api/Operation/MessageHeader/Get?begin=${that.rdate[0]}&end=${that.rdate[1]}&sendType=${that.sendType}`)
                req.then(data => {
                    let r = data
                    resolve(r)
                }).catch(e => {
                    resolve([])
                })
            })
        },
        loadUsers() {
            let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
            req.then((data) => {
                this.users = _.map(data, d => {
                    return {
                        value: d.id,
                        label: d.dic_worker_name || `--`,
                        code: d.username,
                        disabled: d.is_deleted
                    }
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadnoticelocation() {
            let options = []
            options.push({
                label: `显示屏`,
                value: `dp_xsp_1`,
                jianpin: `xsp`,
                code: `xsp`,
                children: [{
                    label: `排程屏`,
                    value: `dp_pc_1`,
                    jianpin: `pcp`,
                    code: `pcp`,
                    parent_value: `dp_xsp_1`
                }]
            })
            this.ward_auth.map(ward => {
                let wardoption = {
                    label: `${ward.label}`,
                    value: `${ward.value}`,
                    jianpin: `${ward.jianpin}`,
                    code: `${ward.code}`
                }
                let children = []
                if (ward.operation_room && ward.operation_room.length > 0) {
                    ward.operation_room.map(room => {
                        children.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            parent_value: `${ward.value}`
                        })
                    })
                } else if (ward.recovery_bed && ward.recovery_bed.length > 0) {
                    ward.recovery_bed.map(room => {
                        children.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            parent_value: `${ward.value}`
                        })
                    })
                }
                if (children.length > 0) {
                    wardoption.children = children
                }
                options.push(wardoption)
            })
            return options
        },
        loadGroup() {
            let req = this.myaxios.get(`/api/AcisSystem/MessageGroup/Get`)
            req.then(data => {
                this.usergroup = data && data.map(d => {
                    return {
                        label: d.name,
                        value: d.id,
                        ac_sys_user_id: d.ac_sys_user_id
                    }
                })
            })
        },
        loadTemplate() {
            let that = this
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/BoardTemplate/Get`)
                req.then(data => {
                    _.map(data, d => {
                        let roomIds = d.dic_operating_room_id && _.split(d.dic_operating_room_id, `,`).map(p => parseInt(p)) || []
                        let bedIds = d.dic_recovery_bed_id && _.split(d.dic_recovery_bed_id, `,`).map(p => parseInt(p)) || []
                        let orooms = []
                        let rbeds = []
                        _.forEach(this.ward_auth, ward => {
                            if (_.has(ward, `operation_room`)) {
                                let wardRoomIds = ward.operation_room.map(o => o.value)
                                let childRoomIds = roomIds.filter(x => wardRoomIds.includes(x))
                                childRoomIds.map(p => {
                                    p = `${ward.value}_${p}`
                                    orooms.push(p)
                                })
                            } else {
                                let wardBedIds = ward.recovery_bed.map(o => o.value)
                                let childBedIds = bedIds.filter(x => wardBedIds.includes(x))
                                childBedIds.map(p => {
                                    p = `${ward.value}_${p}`
                                    rbeds.push(p)
                                })
                            }
                        })
                        d.board_type && _.split(d.board_type, `,`).map(p => {
                            p = `dp_pc_${p}`
                            rbeds.push(p)
                        })

                        let wards = orooms.concat(rbeds)

                        d.dic_ward_ids = wards

                        d.sys_messagegroup_ids = d.sys_messagegroup_ids && _.split(d.sys_messagegroup_ids, `,`).map(p => parseInt(p))
                        let users = d.ac_sysUser_ids && _.split(d.ac_sysUser_ids, `,`).map(p => parseInt(p))
                        if (users && users.length == 1 && users[0] == 0) {
                            d.ac_sysUser_ids = []
                            d.all = true
                        } else {
                            d.all = false
                            d.ac_sysUser_ids = users
                        }

                        d.modify_date = this.$moment(d.modify_date).format(`YYYY/MM/DD HH:mm`)
                    })

                    data = _.filter(data, r => {
                        return r.send_type && r.send_type > 0
                    })
                    if (that.dic_ward_id) {
                        data = _.filter(data, r => {
                            return _.includes(r.dic_ward_ids, that.dic_ward_id) || r.send_type == 2
                        })
                    }
                    this.templateList = data
                    this.templateoption = data.map(item => {
                        return {
                            label: item.name,
                            value: item.id,
                            type: item.send_type
                        }
                    })
                    console.log(this.templateList)
                    console.log(this.templateoption)
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        saveMessage(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/Operation/MessageHeader/Save`, row)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        loadSendMessageView({ row }) {
            this.message.messageId = row.id
            console.log(row)
            if (row.send_type === 2) {
                this.message.title = `请选择接收人`
            } else if (row.send_type === 1) {
                this.message.title = `请选择接收位置`
            }
            let template = this.templateList.find(s => s.id == row.sys_board_template_id)
            if (template) {
                row.all = template.all
                row.sys_message_group_array = template.sys_messagegroup_ids
                row.ac_sys_user_array = template.ac_sysUser_ids
                row.notice_location = template.dic_ward_ids
            }
            let data = row
            this.message.data = data
            this.message.dialogFormVisible = true
        },
        retractMessage({ row }) {
            this.$confirm(`撤回后不可重新发送, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let r = { ...row }
                r.enum_message_status = 2
                this.saveMessage(r).then(() => {
                    this.$refs[`message-list`].ReloadListData()
                })
            })
        },
        sendMessage(row) {
            // 消息发送
            if (row.send_type == 2) {
                let gs = _.filter(this.usergroup, d => (row.sys_message_group_array || []).indexOf(d.value) > -1)
                gs = _.flatMap(gs, d => d.ac_sys_user_id)
                gs = _.uniq(gs.concat(row.ac_sys_user_array || []))
                if (!row.all && gs.length == 0) {
                    this.$message.warning(`请选择接收人`)
                    return
                }
                row.enum_message_status = 1
                this.saveMessage(row).then(data => {
                    let req = this.myaxios.post(`/api/Operation/MessageReceive/Post?messageId=${this.message.messageId}`, row.all ? [0] : gs)
                    req.then(() => {
                        this.$refs[`message-list`].ReloadListData()
                        this.message.dialogFormVisible = false
                    })
                })
            } else {
                console.log(row)
                console.log(this.ward_auth)
                let dicoperatingwardid = []
                let dicoperatingroomid = []
                let dicrecoverywardid = []
                let dicrecoverybedid = []
                let boardtype = ``
                row.notice_location.map(item => {
                    // item 格式为 rw_手术区id_手术间id
                    let itemarr = item.split(`_`)
                    let pvalue = itemarr[0] + `_` + itemarr[1]
                    let pitemvalue = parseInt(itemarr[1])
                    let itemvalue = parseInt(itemarr[2])
                    // 找对应的手术区或者复苏区
                    let auth = _.find(this.ward_auth, { value: pvalue })
                    if (item.indexOf(`all`) > -1) {
                        if (item.indexOf(`ow`) > -1) {
                            if (!dicoperatingwardid.includes(pitemvalue)) {
                                dicoperatingwardid.push(pitemvalue)
                            }
                            auth.operation_room.map(r => {
                                if (!dicoperatingroomid.includes(r.value)) {
                                    dicoperatingroomid.push(r.value)
                                }
                            })
                        } else if (item.indexOf(`rw`) > -1) {
                            if (!dicrecoverywardid.includes(pitemvalue)) {
                                dicrecoverywardid.push(pitemvalue)
                            }
                            auth.recovery_bed.map(r => {
                                if (!dicrecoverybedid.includes(r.value)) {
                                    dicrecoverybedid.push(r.value)
                                }
                            })
                        }
                    } else if (item.indexOf(`dp`) > -1) {
                        boardtype = itemvalue
                    } else if (item.indexOf(`ow`) > -1) {
                        if (!dicoperatingroomid.includes(itemvalue)) {
                            dicoperatingroomid.push(itemvalue)
                        }
                        if (!dicoperatingwardid.includes(pitemvalue)) {
                            dicoperatingwardid.push(pitemvalue)
                        }
                    } else if (item.indexOf(`rw`) > -1) {
                        if (!dicrecoverybedid.includes(itemvalue)) {
                            dicrecoverybedid.push(itemvalue)
                        }
                        if (!dicrecoverywardid.includes(pitemvalue)) {
                            dicrecoverywardid.push(pitemvalue)
                        }
                    }
                })
                row.dic_operating_room_array = dicoperatingroomid
                row.dic_operating_ward_array = dicoperatingwardid
                row.dic_recovery_bed_array = dicrecoverybedid
                row.dic_recovery_ward_array = dicrecoverywardid
                row.board_type = boardtype
                row.enum_message_status = 1
                this.saveMessage(row).then(data => {
                    row.surgeryId = this.surgeryId || null
                    row.type = `BB`

                    _.each(row, (value, key) => {
                        /* eslint valid-typeof: "error" */
                        if (row[key] && (row[key] + ``).indexOf(`/Date`) > -1) {
                            row[key] = this.$moment(row[key]).format(`YYYY/MM/DD HH:mm`)
                        }
                    })

                    let msgData = JSON.stringify(row)
                    //             this.surgeryId = 3488
                    //             let title = row.title == null ? `` : row.title
                    //             let msgData = `{
                    //   "id":"${this.$moment()}",
                    //   "surgeryId":"${this.surgeryId}",
                    //   "title":"${title}",
                    //   "content":"${row.content}",
                    //   "dic_operating_room_id":"${row.dic_operating_room_id}",
                    //   "dic_recovery_bed_id":"${row.dic_recovery_bed_id}",
                    //   "type":"BB"
                    // }`
                    // 播报发送
                    let req = this.myaxios.post(`/api/Operation/BoardNotice/SendMessage?msg=${msgData}`)
                    req.then(data => {
                        this.$message.info(`已通知`)
                        this.$refs[`message-list`].ReloadListData()
                        this.message.dialogFormVisible = false
                    }).catch(e => {
                        console.log(e)
                    })
                })
            }
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`message-list`].ReloadListData()
        },
        sendType: function(newVlaue, oldValue) {
            this.$refs[`message-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Message/MessageSend.vue